"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportViewSnapshots = exports.reportViewEditorList = exports.reportViewConfig = exports.reportUpdateReset = exports.reportUpdate = exports.reportUnrestrict = exports.reportUnlocked = exports.reportSuccess = exports.reportSubmit = exports.reportSoftDeleteRestore = exports.reportSoftDeleteList = exports.reportSoftDelete = exports.reportRestrict = exports.reportReset = exports.reportRead = exports.reportPlay = exports.reportPause = exports.reportLockedUnlockedReset = exports.reportLocked = exports.reportListReviewAndApproval = exports.reportList = exports.reportFilter = exports.reportError = exports.reportEditSaveReset = exports.reportEditSave = exports.reportEdit = exports.reportDownloadEmail = exports.reportDeleteReset = exports.reportDelete = exports.reportChangeReset = exports.reportChange = exports.reportBuildList = exports.reportApprove = exports.addReport = void 0;
var _report = require("./report.constant");
// @flow

// common success
var reportSuccess = function reportSuccess(actionType, data) {
  return {
    type: _report.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportSuccess = reportSuccess;
var reportError = function reportError(actionType, error) {
  return {
    type: _report.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};
/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add report.
 */
exports.reportError = reportError;
var reportEditSave = function reportEditSave(payload) {
  return {
    type: _report.actionTypes.EDIT_SAVE,
    payload: payload
  };
};

/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add report.
 */
exports.reportEditSave = reportEditSave;
var reportEditSaveReset = function reportEditSaveReset(payload) {
  return {
    type: _report.actionTypes.EDIT_SAVE_RESET,
    payload: payload
  };
};
/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add report.
 */
exports.reportEditSaveReset = reportEditSaveReset;
var reportEdit = function reportEdit(payload) {
  return {
    type: _report.actionTypes.EDIT,
    payload: payload
  };
};

/**
 * read report
 * @param payload
 * @returns api response
 * @description this function used to read report.
 */
exports.reportEdit = reportEdit;
var reportRead = function reportRead(payload) {
  return {
    type: _report.actionTypes.READ,
    payload: payload
  };
};

/**
 * change report
 * @param payload
 * @returns api response
 * @description this function used to change report.
 */
exports.reportRead = reportRead;
var reportChange = function reportChange(payload) {
  return {
    type: _report.actionTypes.CHANGE,
    payload: payload
  };
};

/**
 * change report
 * @param payload
 * @returns api response
 * @description this function used to change report.
 */
exports.reportChange = reportChange;
var reportChangeReset = function reportChangeReset() {
  return {
    type: _report.actionTypes.RESET_CHANGE
  };
};
/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add report..
 */
exports.reportChangeReset = reportChangeReset;
var addReport = function addReport(payload) {
  return {
    type: _report.actionTypes.ADD_REPORT,
    payload: payload
  };
};

/**
 * list of report
 * @param payload
 * @returns api response
 * @description this function used to list of report.
 */
exports.addReport = addReport;
var reportList = function reportList(payload) {
  return {
    type: _report.actionTypes.LIST,
    payload: payload
  };
};

/**
 * list of report
 * @param payload
 * @returns api response
 * @description this function used to list of report.
 */
exports.reportList = reportList;
var reportListReviewAndApproval = function reportListReviewAndApproval(payload) {
  return {
    type: _report.actionTypes.LIST_REVIEW_APPROVAL,
    payload: payload
  };
};

/**
 * submit report
 * @param payload
 * @returns api response
 * @description this function used to submit report.
 */
exports.reportListReviewAndApproval = reportListReviewAndApproval;
var reportSubmit = function reportSubmit(payload) {
  return {
    type: _report.actionTypes.SUBMIT,
    payload: payload
  };
};

/**
 * approve report
 * @param payload
 * @returns api response
 * @description this function used to approve report.
 */
exports.reportSubmit = reportSubmit;
var reportApprove = function reportApprove(payload) {
  return {
    type: _report.actionTypes.APPROVE,
    payload: payload
  };
};

/**
 * delete report
 * @param payload
 * @returns api response
 * @description this function used to delete report.
 */
exports.reportApprove = reportApprove;
var reportDelete = function reportDelete(payload) {
  return {
    type: _report.actionTypes.DELETE,
    payload: payload
  };
};

/**
 * delete report
 * @param payload
 * @returns api response
 * @description this function used to delete report.
 */
exports.reportDelete = reportDelete;
var reportDeleteReset = function reportDeleteReset(payload) {
  return {
    type: _report.actionTypes.DELETE_RESET,
    payload: payload
  };
};

/**
 * filter of report
 * @param payload
 * @returns api response
 * @description this function used to filter of report.
 */
exports.reportDeleteReset = reportDeleteReset;
var reportFilter = function reportFilter(payload) {
  return {
    type: _report.actionTypes.FILTER,
    payload: payload
  };
};

/**
 * pause report
 * @param payload
 * @returns api response
 * @description this function used to pause report.
 */
exports.reportFilter = reportFilter;
var reportPause = function reportPause(payload) {
  return {
    type: _report.actionTypes.PAUSE,
    payload: payload
  };
};

/**
 * build list report
 * @param payload
 * @returns api response
 * @description this function used to build list report.
 */
exports.reportPause = reportPause;
var reportBuildList = function reportBuildList(payload) {
  return {
    type: _report.actionTypes.BUILD_LIST,
    payload: payload
  };
};

/**
 * play report
 * @param payload
 * @returns api response
 * @description this function used to play report.
 */
exports.reportBuildList = reportBuildList;
var reportPlay = function reportPlay(payload) {
  return {
    type: _report.actionTypes.PLAY,
    payload: payload
  };
};

/**
 * email
 * @param payload
 * @returns api response
 * @description this function used to email.
 */
exports.reportPlay = reportPlay;
var reportDownloadEmail = function reportDownloadEmail(payload) {
  return {
    type: _report.actionTypes.DOWNLOAD_EMAIL,
    payload: payload
  };
};

/**
 * restrict report
 * @param payload
 * @returns api response
 * @description this function used to restrict report.
 */
exports.reportDownloadEmail = reportDownloadEmail;
var reportRestrict = function reportRestrict(payload) {
  return {
    type: _report.actionTypes.RESTRICT,
    payload: payload
  };
};

/**
 * unrestrict report
 * @param payload
 * @returns api response
 * @description this function used to unrestrict report.
 */
exports.reportRestrict = reportRestrict;
var reportUnrestrict = function reportUnrestrict(payload) {
  return {
    type: _report.actionTypes.UNRESTRICT,
    payload: payload
  };
};

/**
 * lock report
 * @param payload
 * @returns api response
 * @description this function used to lock report.
 */
exports.reportUnrestrict = reportUnrestrict;
var reportLocked = function reportLocked(payload) {
  return {
    type: _report.actionTypes.LOCKED,
    payload: payload
  };
};

/**
 * unlock report
 * @param payload
 * @returns api response
 * @description this function used to unlock report.
 */
exports.reportLocked = reportLocked;
var reportUnlocked = function reportUnlocked(payload) {
  return {
    type: _report.actionTypes.UNLOCKED,
    payload: payload
  };
};

/**
 * lock unlock reset report
 * @param payload
 * @returns api response
 * @description this function used to reset report.
 */
exports.reportUnlocked = reportUnlocked;
var reportLockedUnlockedReset = function reportLockedUnlockedReset(payload) {
  return {
    type: _report.actionTypes.LOCKED_UNLOCKED_RESET,
    payload: payload
  };
};

/**
 * view snapshots
 * @param payload
 * @returns api response
 * @description this function used to view snapshots.
 */
exports.reportLockedUnlockedReset = reportLockedUnlockedReset;
var reportViewSnapshots = function reportViewSnapshots(payload) {
  return {
    type: _report.actionTypes.VIEW_SNAPSHOTS,
    payload: payload
  };
};

/**
 * view editos of report
 * @param payload
 * @returns api response
 * @description this function used to view editos of report.
 */
exports.reportViewSnapshots = reportViewSnapshots;
var reportViewEditorList = function reportViewEditorList(payload) {
  return {
    type: _report.actionTypes.VIEW_EDITOR_LIST,
    payload: payload
  };
};

/**
 * view config of report
 * @param payload
 * @returns api response
 * @description this function used to view config of report.
 */
exports.reportViewEditorList = reportViewEditorList;
var reportViewConfig = function reportViewConfig(payload) {
  return {
    type: _report.actionTypes.VIEW_CONFIG,
    payload: payload
  };
};

/**
 * report update
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.reportViewConfig = reportViewConfig;
var reportUpdate = function reportUpdate(payload) {
  return {
    type: _report.actionTypes.UPDATE_REPORT,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.reportUpdate = reportUpdate;
var reportUpdateReset = function reportUpdateReset() {
  return {
    type: _report.actionTypes.RECORD_UPDATE_RESET
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.reportUpdateReset = reportUpdateReset;
var reportReset = function reportReset(payload) {
  return {
    type: _report.actionTypes.RESET,
    payload: payload
  };
};

/**
 * soft delete report
 * @param payload
 * @returns api response
 * @description this function used to soft delete report.
 */
exports.reportReset = reportReset;
var reportSoftDelete = function reportSoftDelete(payload) {
  return {
    type: _report.actionTypes.SOFT_DELETE,
    payload: payload
  };
};

/**
 * soft delete report
 * @param payload
 * @returns api response
 * @description this function used to soft delete report.
 */
exports.reportSoftDelete = reportSoftDelete;
var reportSoftDeleteList = function reportSoftDeleteList(payload) {
  return {
    type: _report.actionTypes.SOFT_DELETE_LIST,
    payload: payload
  };
};

/**
 * soft delete report
 * @param payload
 * @returns api response
 * @description this function used to soft delete report.
 */
exports.reportSoftDeleteList = reportSoftDeleteList;
var reportSoftDeleteRestore = function reportSoftDeleteRestore(payload) {
  return {
    type: _report.actionTypes.SOFT_DELETE_RESTORE,
    payload: payload
  };
};
exports.reportSoftDeleteRestore = reportSoftDeleteRestore;